import { Link } from "react-router-dom";
const HomePanchakarma = () => {
  return <section className="w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4">
                {
    /* Mobile Layout - sm and below */
  }
                <div className="lg:hidden flex flex-col gap-8">
                    {
    /* Label */
  }
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                        Panchakarma
                    </p>
                    <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                        Die Essenz der Ayurveda-Behandlung zur Rückkehr in innere Balance.
                    </h2>

                    {
    /* Image */
  }
                    <div className="relative h-[280px] overflow-hidden sm:h-[380px]">
                        <img
    src="/images/Hiru/front_panchkarma_teaser.webp"
    alt="Panchakarma-Behandlungsbild"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                    </div>

                    {
    /* Content */
  }
                    <div>


                        <p className="mt-6 text-base font-semibold leading-relaxed text-[#1f4d3c] sm:text-lg">
                            Alte Weisheit für moderne Beschwerden
                        </p>

                        <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-700 sm:text-base">
                            <p>
                                Die Panchakarma-Therapie ist eine der tiefgründigsten und wirksamsten Methoden der Ayurveda-Reinigung und Regeneration. Der Sanskritbegriff bedeutet „fünf Verfahren“ und umfasst sorgfältig abgestufte Schritte wie die Reinigung des Körpers, die Verfeinerung des Stoffwechsels, die Wiederherstellung von Gewebe, die Harmonisierung der Lebensenergie und die Förderung von innerer Balance.
                            </p>
                            <p>
                                Sie kann gezielt auf Beschwerden reagieren, die im modernen Alltag häufig auftreten – etwa Verdauungsprobleme, Kreislaufstörungen, Migräne, emotionale Erschöpfung und innere Unruhe. Ziel ist es, die Ursache sanft anzugehen und den Körper von innen heraus wieder ins Gleichgewicht zu bringen.
                            </p>
                            <p>
                                Wie die Sonne des Resorts „Hiru“ die Wolken vertreibt und die Welt freundlich erhellt, entfernt Panchakarma sanft alles Überflüssige und hilft dabei, das natürliche Leuchten von Körper und Geist wieder zu entfachen.
                            </p>
                        </div>

                        <div className="mt-8">
                            <Link
    to="/ayurveda/panchakarma"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr erfahren
                            </Link>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout - lg and above */
  }
                <div className="hidden lg:flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">
                    <div className="lg:w-5/12">
                        <div className="relative h-[320px] overflow-hidden sm:h-[420px] lg:h-[560px]">
                            <img
    src="/images/Hiru/front_panchkarma_teaser.webp"
    alt="Panchakarma-Behandlungsbild"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>

                    <div className="lg:w-7/12">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                            Panchakarma
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Die Essenz der Ayurveda-Behandlung zur Rückkehr in innere Balance.
                        </h2>

                        <p className="mt-8 text-lg font-semibold leading-relaxed text-[#1f4d3c]">
                            Alte Weisheit für moderne Beschwerden
                        </p>

                        <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                            <p>
                                Die Panchakarma-Therapie ist eine der tiefgründigsten und wirksamsten Methoden der Ayurveda-Reinigung und Regeneration. Der Sanskritbegriff bedeutet „fünf Verfahren“ und umfasst sorgfältig abgestufte Schritte wie die Reinigung des Körpers, die Verfeinerung des Stoffwechsels, die Wiederherstellung von Gewebe, die Harmonisierung der Lebensenergie und die Förderung von innerer Balance.
                            </p>
                            <p>
                                Sie kann gezielt auf Beschwerden reagieren, die im modernen Alltag häufig auftreten – etwa Verdauungsprobleme, Kreislaufstörungen, Migräne, emotionale Erschöpfung und innere Unruhe. Ziel ist es, die Ursache sanft anzugehen und den Körper von innen heraus wieder ins Gleichgewicht zu bringen.
                            </p>
                            <p>
                                Wie die Sonne des Resorts „Hiru“ die Wolken vertreibt und die Welt freundlich erhellt, entfernt Panchakarma sanft alles Überflüssige und hilft dabei, das natürliche Leuchten von Körper und Geist wieder zu entfachen.
                            </p>
                        </div>

                        <div className="mt-10">
                            <Link
    to="/ayurveda/panchakarma"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr über Panchakarma erfahren
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomePanchakarma;
